import { Entity } from "../helpers/Entity"

export type LabelAttributes = {
    title: string,
    type: string,
}

export type LabelDto = {
    id: string,
    type: string,
    attributes: LabelAttributes,
}

export default class Label implements Entity {
    private id: string
    private type: string
    private attributes: LabelAttributes
    constructor(dto: LabelDto) {
        this.id = dto.id
        this.type = dto.type
        this.attributes = dto.attributes
    }

    isLoaded() {
        return this.id != "" && this.type == "labels"
    }

    getId() {
        return this.id
    }

    getType() {
        return this.attributes.type
    }

    getTitle() {
        return this.attributes.title
    }

}



// WEBPACK FOOTER //
// ./src/state/label/Label.ts